<template>
    <div>
        <TableList :form_data_seo.sync="form_data_seo" :columns="columns" :get_table_list="this.get_table_list"
            ref="barrel" :expandRowByClick="false" @expandedRowsChange="handleExpandedRowsChange($event)"
            :expandedRowRender="true" :submit_preprocessing="submit_preprocessing" @changeStatus="changeStatus"
            :slot_table_list="['operation','operations']" :rowKey="'id'" @list_after="list_after">
            <!-- <template slot="right_btn">
			    <a v-if="this.$store.state.page_auth.export" @click="report()">
					<a-button class="a_btn">导出</a-button>
				</a>
			</template> -->
            <template slot="operation" slot-scope="data">
                <a @click="go_detail(data.record)">查看</a>
                <a-divider type="vertical" v-if="data.record.need_again == 1" />
                <a-popover placement="left" v-if="data.record.need_again == 1">
                    <template slot="content">
                        <p>{{data.record.error_reason}}</p>
                    </template>
                    <template slot="title">
                        <span>原因</span>
                    </template>
                    <a @click="overload(data.record)" v-if="data.record.need_again == 1">重推</a>
                </a-popover>
            </template>
            <template slot="expandedRowRender" slot-scope="data">
                <a-table :columns="columns_sub" :pagination="false" :dataSource="children_list[data.record.id + '']"
                    style="margin: 0">
                    <!-- <template slot="footer" slot-scope>
                        <div
                            style="text-align:right"
                        >共{{data.record.goods.goods_num}}件商品，总计：¥{{data.record.goods.goods_total}}</div>
                    </template> -->
                    <template slot="emptyBarrelInfo"
                        slot-scope="text,record">{{record.emptyBarrelInfo ? '桶装' : '瓶装'}}</template>

                    <template slot="operations" slot-scope="record">
                        <a @click="go_detail(record)">查看</a>
                    </template>
                </a-table>
            </template>
        </TableList>

    </div>
</template>

<script>
    // @ is an alias to /src
    import EditPop from "@/components/EditPop";
    import Form from "@/components/Form";
    import {
        get_empty_barrel,
        get_seller_empty,
        pushEmptyBarrel
    } from "@/api/push";
    import TableList from "@/components/TableList";
    import {
        Modal
    } from 'ant-design-vue'
    const columns = [{
		    title: "空桶单号",
		    dataIndex: "barrel_no",
		},{
            title: "仓库",
            dataIndex: "storage_name",
        },
        {
            title: "司机",
            dataIndex: "chauffeur",
        },
        {
            title: "司机电话",
            dataIndex: "chauffeur_mobile",
        },
        {
            title: "车牌",
            dataIndex: "truck_license",
        },
        {
            title: "仓管",
            dataIndex: "username",
        },
		
        {
            title: "状态",
            dataIndex: "status_name",
        },
        {
            title: "创建时间",
            dataIndex: "create_time",
        },
        {
            title: "操作",
            scopedSlots: {
                customRender: "operation"
            }
        }
    ];

    const columns_sub = [{
            title: "经销商",
            dataIndex: "seller_name",
        },
        {
            title: "经销商编号",
            dataIndex: "seller_id",
        },
        {
            title: "空桶数量",
            dataIndex: "num",
        },
        {
            title: "操作",
            scopedSlots: {
                customRender: "operations"
            }
        }
    ];

    export default {
        name: "Index",
        components: {
            EditPop,
            Form,
            TableList
        },
        data() {
            return {
                submit_preprocessing: {
                    array_to_string: ['department']
                },
                get_table_list: get_empty_barrel,
                columns,
                columns_sub,
                visible: false,
                form_data_seo: {
                    list: [{
                            type: "text",
                            name: "keyword",
                            title: "关键词",
                            placeholder: '仓管/仓库/司机/车牌',
                            options: {},
                        },
                        // {
                        //     type: "tree-select",
                        //     name: "department",
                        //     title: "部门",
                        //     options: {},
                        //     treeData: [],
                        //     multiple: true
                        // },
						{
						    type: "text",
						    name: "barrel_no",
						    title: "空桶单号",
						    placeholder: '请输入',
						    options: {
						    }
						},
                        {
                            type: "text",
                            name: "out_trade_no",
                            title: "单号",
                            placeholder: '请输入',
                            options: {
                            }
                        },
                        {
                            type: "select",
                            name: "status",
                            title: "状态",
                            mode: "default",
                            options: {},
                            list: [{
                                    key: 0,
                                    value: '待核查'
                                },
                                {
                                    key: 1,
                                    value: '仓库录入中'
                                },
                                {
                                    key: 2,
                                    value: '仓库核对完成'
                                },
                                {
                                    key: 3,
                                    value: '司机核对完成'
                                },
                            ]
                        },
                        {
                            type: "range_date",
                            name: "range_date",
                            title: "创建时间",
                            options: {
                                initialValue: [this.$moment(new Date(new Date().getTime() - (30 * 24 * 60 * 60 *
                                    1000)), 'YYYY/MM/DD'), this.$moment(new Date(), 'YYYY/MM/DD')],
                            },
                            start: {
                                name: 'start_time'
                            },
                            end: {
                                name: 'end_time'
                            },
                        },
                    ],
                    ...this.$config.form_data_seo
                },
                form_data: {},
                children_list: {},
                check_open: [],
            };
        },
        created() {
            this.$method.get_department().then(res => {
                this.form_data_seo.list = this.$method.set_form_list(this.form_data_seo.list, 'department',
                    'treeData', res)
            });
        },
        mounted() {
            // window.addEventListener('popstate', this.handleBackSendButton,false);
        },
        activated() {
            // this.$refs.barrel.get_list();
        },
        methods: {
            handleBackSendButton() {
                this.$refs.barrel.get_list();
            },
            handleExpandedRowsChange(e) {
                this.check_open = e
                e.forEach(item => {
                    if (this.children_list[item]) {} else {
                        get_seller_empty({
                            data: {
                                id: item,
                            }
                        }).then(res => {
                            this.$set(this.children_list, item + '', res.data.list);
                        })
                    }
                })
            },
            go_detail(e) {
                this.$keep_route.add(this.$options.name);
                this.$router.push({
                    path: "/barrel/details",
                    query: {
                        id: e.id,
                        seller_id: e.seller_id ? e.seller_id : ''
                    }
                })
            },
            // 重载
            overload(data) {
                let that = this
                Modal.confirm({
                    title: '温馨提示',
                    content: '确定执行重推吗？',
                    okText: '确认',
                    cancelText: '取消',
                    onOk() {
                        pushEmptyBarrel({
                            data: {
                                id: data.id
                            },
                            info: true,
                            loading: true
                        }).then(() => {
                            that.$refs.barrel.get_list();
                        })
                    }
                });
            },
            changeStatus(e) {
                this.children_list = {}
            },
            list_after() {
                this.$nextTick(() => {
                    this.handleExpandedRowsChange(this.check_open)
                })
            }
        }
    };
</script>

<style lang="less">
    @import url("../../../assets/less/app.less");
</style>